module.exports = __webpack_public_path__ + "img/11.a8b7864e.jpg";